import { render, staticRenderFns } from "./DocumentRequestTab.vue?vue&type=template&id=6d276bdc&scoped=true"
import script from "./DocumentRequestTab.vue?vue&type=script&lang=js"
export * from "./DocumentRequestTab.vue?vue&type=script&lang=js"
import style0 from "./DocumentRequestTab.vue?vue&type=style&index=0&id=6d276bdc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d276bdc",
  null
  
)

export default component.exports